(function () {

    'use strict';

    /**
     * Initiates the expandable navigation.
     */
    const Detail = function (element) {

        this.element = element;
        this.details = element.getElementsByClassName('details__detail');
        this.covers = element.getElementsByClassName('details__cover');

        this.toggleState = this.toggleState.bind(this);

        this.initiateListener();
    }

    /**
     * Initiates the listener.
     */
    Detail.prototype.initiateListener = function () {

        this.element.addEventListener('pointerdown', this.toggleState);
    }

    /**
     * Toggle the state.
     */
    Detail.prototype.toggleState = function (event) {

        if (event.target.tagName === 'SUMMARY') {

            for (const cover of this.covers) {

                if (cover.dataset.index === event.target.dataset.index) {
                    cover.classList.toggle('details__cover--open');

                } else {
                    cover.classList.remove('details__cover--open');
                }
            }
        }
    }

    const details = document.getElementsByClassName('js-detail');

    for (const detail of details) {
        new Detail(detail);
    }
}());